import React from 'react'

import { type TrayCardImage } from '../../../../../firebase/model/tray-cards/types/image-model'

import './FloorTrayImage.scss'

interface FloorTrayImageProps {
  trayCard: TrayCardImage
}

const FloorTrayImage = ({ trayCard }: FloorTrayImageProps) => {
  return <img className="floor-tray-image" src={trayCard.thumbnail} alt="" />
}

export { FloorTrayImage }
